import { memo } from "react";
import { useUserContext } from "../contexts/UserContext";
import { useFetchAllFilters } from "../hooks/useFetchAllFilters"

export const FetchFilterController = memo(() => {
  const { currentUser, isGuestUser } = useUserContext();

  // Allow guest users to see the filters on the product page by always calling the filter's API for them.
  useFetchAllFilters({ skip: isGuestUser() ? false : !currentUser?.id }, [currentUser?.id]);

  return null;
})